import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { Section, SelectorIdentifier } from '../../../models';
import { TritonSectionIds } from '../base-config-models';
import { LocationCardSettings } from '../../../reducers';
import { SamplerFieldIds } from './config-models';
import { field } from '../../../core/field-schema';
import { required, pattern } from '../../../core/validator-builders';
import { Selectable } from 'app/shared/models/selectable';
import { SamplerTypeOption } from 'app/shared/components/location-card/models/location-card.model';
import { SamplerDevice } from '../models';
import { samplerTypeChange } from '../../../actions/triton-actions';

/**
 * Sampler configuration
 */
export const samplerConfig = (settings: LocationCardSettings, samplerInfo?: SamplerDevice): Section => {
    const samplingType = samplerInfo ? samplerInfo.samplingType : 0;
    const isOff = !samplingType;

    return {
        info: {
            id: TritonSectionIds.Sampler,
            title: 'SAMPLER',
            expandable: true,
            displayTitle: true,
            expanded: false,
        },
        rows: [
            {
                info: {
                    id: 'sampler-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.select<SamplerTypeOption, number>(SamplerFieldIds.SamplingType, 'samplingType', {
                        placeholder: 'COMMON.TYPE_COLUMN_TITLE',
                        valueMapper: (option) => option.id,
                        displayMapper: (option) => option.name,
                        value: samplerInfo ? samplerInfo.samplingType : 0,
                        optionsSelector: SelectorIdentifier.SamplerTypes,
                        panelClass: 'width-20',
                        events: {
                            onChange: (option: SamplerTypeOption) => [
                                samplerTypeChange({ samplingType: option.id }),
                            ],
                        },
                    }),
                    field.number(SamplerFieldIds.Trigger, 'trigger', {
                        placeholder: 'COMMON.TRIGGER',
                        value: samplerInfo ? samplerInfo.trigger : 0,
                        validators: isOff
                            ? []
                            : [
                                required(),
                                pattern({
                                    value: REGEX_CONFIG.numericDecimal2PlacePattern,
                                }),
                            ],
                        panelClass: 'width-20 required',
                    }),
                    field.select<Selectable, number>(SamplerFieldIds.SamplesPerWakeup, 'samplesPerWakeup', {
                        placeholder: 'COMMON.SAMPLER_PER_WAKEUP',
                        valueMapper: (option) => option.id,
                        displayMapper: (option) => option.name,
                        value: samplerInfo ? samplerInfo.samplesPerWakeup : 1,
                        optionsSelector: SelectorIdentifier.SamplerPerWakeupOptions,
                        panelClass: 'width-20',
                    }),
                    field.select<Selectable, number>(SamplerFieldIds.Delay, 'delay', {
                        placeholder: 'COMMON.PULSE_LENGTH',
                        valueMapper: (option) => option.id,
                        displayMapper: (option) => option.name,
                        value: samplerInfo ? samplerInfo.delay : 2,
                        optionsSelector: SelectorIdentifier.SamplerPulseLengthOptions,
                        panelClass: 'width-20',
                    }),
                ],
            },
        ],
    };
};
